import { VariablesT } from "../../../types/Company"
import { JobTypeTStrings, LocationT } from "../../../types/Job"
import { getDistance } from "../../../utils/helperMaps"
import { getDirections } from "../../../utils/MapboxClient"

/**
* If truck and
* 1) one location, then it's Intrastate Local,
* 2) two locations, but within the the local intrastate margin, then Intrastate Local,
* 3) two locations that are longer than the local intrastate margin, Intrastate Long-distance Moving,
* 4) If within two different states, 'Interstate'
* @param locations
* @param useTruck
* @returns
*/
export const resolveJobTypeFromLocations = async (locations: Array<LocationT>, useTruck: boolean, companyVariables: VariablesT): Promise<JobTypeTStrings> => {
    let jobType: JobTypeTStrings = null


    if (useTruck) {
        if (locations.length == 1) {
            jobType = "intrastate_local"
        } else if (locations.length > 1) {
            let inState = locationsInState(locations)
            if (!inState) {
                return "interstate"
            }

            let distance = await parseDistance(locations)

            if (distance > companyVariables.localIntrastateMargin.value) {
                jobType = "intrastate_long"
            } else {
                jobType = "intrastate_local"
            }
        }

    } else {
        jobType = 'moving_labor'
    }

    return jobType

}

/**
*
* @param locations
* @returns
*/
const parseDistance = async (locations: Array<LocationT>): Promise<number> => {
    let distance = 0
    try {

        if (locations.length > 2) {
            let result = await getDirections(locations)
            distance = result.distanceMailes
        } else if (locations.length == 2) {
            distance = getDistance(locations[0], locations[1])
        }
    } catch (error) {
        console.log("error", error)
    }
    return distance
}
/**
* locationsInState
* @param locations
* @returns
*/
const locationsInState = (locations: Array<LocationT>): boolean => {
    let findLocation = locations.find((loction, index) => {
        return locations.find((item) => {
            return item.addressState != loction.addressState
        })
    })
    return !findLocation ? true : false
}

